import React from 'react';
import { Typography } from '@mui/material';
import { colors } from 'theme/colors';
import Icon from 'components/atoms/Icon/Icon';
import { EIconTypes } from 'constants/Icons';
import { useAlert } from 'models/alertContext';
import { StyledIconCloseWrapper, StyledIconWrapper, StyledWrapper } from './styles';

export enum EAlertVariants {
  success = 'success',
  warning = 'warning',
  error = 'error',
}

export interface IAlert {
  text: string;
  variant?: EAlertVariants;
  type?: string;
}

export const Alert = ({ text, variant = EAlertVariants.success, type }: IAlert) => {
  const { clearAlert } = useAlert();
  const onClose = () => {
    if (type) {
      clearAlert(type);
    }
  };

  let icon: EIconTypes;
  let iconBackgroundColor: string;
  let backgroundColor: string;
  let borderColor: string;
  let textColor: string;
  switch (variant) {
    case EAlertVariants.success:
      textColor = colors.success600;
      backgroundColor = colors.success50;
      borderColor = colors.success700;
      iconBackgroundColor = colors.success600;
      icon = EIconTypes.checkmark;
      break;
    case EAlertVariants.warning:
      textColor = colors.warning700;
      backgroundColor = colors.warning50;
      borderColor = colors.warning700;
      iconBackgroundColor = colors.warning700;
      icon = EIconTypes.info;
      break;
    case EAlertVariants.error:
      textColor = colors.error700;
      backgroundColor = colors.error50;
      borderColor = colors.error600;
      iconBackgroundColor = colors.error700;
      icon = EIconTypes.priorityHighIcon;
      break;
    default:
      textColor = colors.success600;
      backgroundColor = colors.success50;
      borderColor = colors.success700;
      iconBackgroundColor = colors.success50;
      icon = EIconTypes.info;
  }
  return (
    <StyledWrapper backgroundColor={backgroundColor} borderColor={borderColor}>
      <StyledIconWrapper iconBackgroundColor={iconBackgroundColor}>
        <Icon type={icon} color={colors.white} fontSize={22} />
      </StyledIconWrapper>
      <Typography variant="body2" color={textColor} ml={2} sx={{ fontWeight: 600 }}>
        {text}
      </Typography>
      {type ? (
        <StyledIconCloseWrapper iconBackgroundColor={iconBackgroundColor} onClick={onClose}>
          <Icon type={EIconTypes.close} color={colors.white} fontSize={28} />
        </StyledIconCloseWrapper>
      ) : (
        ''
      )}
    </StyledWrapper>
  );
};
